<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo"/>
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <div class="tile internbackground painel">
            <div class="navbackground">
              <p>
                Olá, seja bem-vindo de volta,
                <span>{{name}}</span>!
              </p>
            </div>
            <div class="tile dash-painel flex-wrap columns is-mobile">
              <div class="column is-6">
                <article class="tile notification tiledash linkbox">
                  <p>Acesse A Biblioteca</p>

                  <router-link :to="{ name: 'aluno/videos', params: { cargo_id }}">
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../assets/images/icon-color/videoaulas.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Videos</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: ''}">
                    <figure @click="isComponentModalActive = true">
                      <div class="imagecontainer">
                        <img
                          src="../../assets/images/icon-color/materiais.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Materiais</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: ''}">
                    <figure @click="isComponentModalActive = true">
                      <div class="imagecontainer">
                        <img
                          src="../../assets/images/icon-color/coletaneas.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Coletâneas</caption>
                    </figure>
                  </router-link>

                  <!-- router-link :to="{ name: ''}">
                    <figure @click="isComponentModalActive = true">
                      <div class="imagecontainer">
                        <img
                          src="../../assets/images/icon-color/folhaderedacao.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Folhas De Redação</caption>
                    </figure>
                  </router-link-->

                  <a
                    href="https://virtualred-buck.s3-sa-east-1.amazonaws.com/VirtualRed/virtual-red-tutorial.pdf"
                    target="_blank"
                  >
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../assets/images/icon-color/tutoriais.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Tutoriais</caption>
                    </figure>
                  </a>
                </article>
              </div>
              <div class="column is-6">
                <div class="tile boxrotate notification tiledash bannerbox blue-gradient">
                  <!-- div id="tabela-propostas">
                    <b-table :data="propostas" :hoverable="true">
                      <template slot-scope="props">
                        

                        <b-table-column label="nome">{{ props.row.nome }}</b-table-column>

                        <b-table-column label="número">{{ props.row.numero }}</b-table-column>

                        <b-table-column label="grade">{{ props.row.grade }}</b-table-column>

                        <b-table-column label="url">{{ props.row.url }}</b-table-column>

                        <b-table-column field="actions" label="Ações" width="180" centered></b-table-column>
                      </template>
                    </b-table>
                  </div-->
                  <router-link :to="{ name: 'aluno/proposta', params: { cargo_id } }">
                    <div class="tile notification tiledashbox">
                      <h1>Últimas propostas</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="column is-4">
                <div class="tile boxrotate notification tiledash bannerbox orange-gradient">
                  <b-icon class="icon-subir-redacao-painel"></b-icon>
                  <img class="balls" src="../../assets/images/icon-color/balls.png" />
                  <h3></h3>

                  <router-link :to="{ name: 'redacao/create' }">
                    <div class="tile notification tiledashbox">
                      <h1>Subir Nova Redação</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="column is-4">
                <div class="tile boxrotate notification bannerbox tiledash pink-gradient">
                  <b-icon class="icon-correcoes-painel"></b-icon>
                  <img class="balls" src="../../assets/images/icon-color/balls.png" />
                  <h3></h3>

                  <router-link :to="{ name: 'redacao', params: { cargo_id } }">
                    <div class="tile notification tiledashbox">
                      <h1>Minhas Redações</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="column is-4">
                <div class="tile boxrotate notification bannerbox tiledash yellow-gradient">
                  <b-icon class="icon-simulados-painel"></b-icon>
                  <img class="balls" src="../../assets/images/icon-color/balls.png" />
                  <h3></h3>

                  <router-link :to="{ name: 'aluno/simulado', params: { cargo_id } }">
                    <div class="tile notification tiledashbox">
                      <h1>Visualizar Simulados</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <internfooter class="footer-painel" />
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <breve />
    </b-modal>
  </div>
</template>
<script>
import PropostaService from "@/services/PropostaService";
import AuthService from "@/services/AuthService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import breve from "@/components/Breve";

import store from "@/store";

export default {
  data() {
    return {
      propostas: [],
      proposta: [],
      cargo_id: store.getters.cargo_id,
      name: store.getters.name,
      isComponentModalActive: false
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    breve: breve
  },
  methods: {
    logout() {
      this.isLoading = true;
      AuthService.logout({})

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "logout realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
        })
        .catch(() => {})
        .finally(() => {});
    }
  },
  created() {
    PropostaService.Index('aluno', this.cargo_id, 1, '', '','').then(result => {
      this.propostas = result;
    });
  }
};
</script>